// import { useState } from 'react'
import React, { useState, useEffect } from "react";
// import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
// import { DropdownList } from '@headlessui/react'
import { useTranslation } from "react-i18next";

import DropdownList from "react-widgets/DropdownList";

export const DropdownListField = ({
  index,
  id,
  name,
  code,
  label,
  placeholder,
  error,
  data,
  setValue,
  getvalue = () => {},
  disabled,
  onChangeValue = () => {},
  extraLabel = '',
  required,
  autoFocus,
  onChange,
  value
}) => {
  // eslint-disable-next-line no-unused-vars
  const [selectedData, setSelectedData] = useState(setValue);
  const { t } = useTranslation();
  useEffect(() => {
    let obj ={
      ...selectedData,
      'textField':name,
      'textCode':code,
      'index':index
    }
    getvalue(obj);
    onChangeValue(index, name, selectedData?.name);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getvalue, selectedData]);

  return (
    <>
      <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">
      {label} {required ? "*" : ""} {extraLabel !== ""? <i className="bi bi-info-circle" title={extraLabel}></i>:""} 
      </label>
      <DropdownList
        id={id}
        name={name}
        className={`dropdownHive w-full rounded-md ${error ? 'is-invalid' : ''}`}
        data={data}
        dataKey={id}
        textField={name}
        defaultValue={''}
        value={value}
        onChange={onChange}
        filter="contains"
        placeholder={placeholder}
        disabled={disabled}
        autoFocus={autoFocus}
      />
      {error &&
        <span className="text-red-500 text-xs">{t("msg_common.thisFieldRequired")}</span>
      }
    </>
  );
};
